// Generated types for IslandPin
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface IslandPinReadAPI extends ScopedNodeReadAPI {
  /** The island the pin is on (its root's id). */
  pinned_island: string;
  /** The pinned island's root class (Unit, Item, Project, ...). */
  pinned_island_type?: string | null;
  /** The exact pinned commit; unresolved only transiently until transaction finalization. */
  commit_id?: string | null;
  /** The covered record's content hash at `commit_id`; every link the pin covers carries it. */
  content_hash?: string | null;
  /** The branch of the pinned island the pin follows. */
  watch_branch?: string;
  /** fresh | available (the island has a newer version the links see a change in) | broken. */
  update_state?: string;
  /** pin (stays at its commit until accepted) | tracking (follows the watched branch). */
  policy?: string;
  /** Chosen on purpose: this version is kept although a route of the holder's other pins reaches another (an override, V33). Set by an explicit choice — Pin it here, Keep as override — never by an automatic pin. */
  deliberate?: boolean;
}

export interface IslandPinWriteAPI extends ScopedNodeWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const IslandPinReadAPISchema: z.ZodType<IslandPinReadAPI> = ScopedNodeReadAPISchemaObject.extend({
  pinned_island: z.string(),
  pinned_island_type: z.string().nullable().optional(),
  commit_id: z.string().nullable().optional(),
  content_hash: z.string().nullable().optional(),
  watch_branch: z.string().optional(),
  update_state: z.string().optional(),
  policy: z.string().optional(),
  deliberate: z.boolean().optional(),
}).passthrough();

export const IslandPinWriteAPISchema: z.ZodType<IslandPinWriteAPI> = ScopedNodeWriteAPISchemaObject.extend({}).passthrough();
